import { MailboxInfo } from 'owa-client-ids';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isConnectedAccount, getUserConfigurationForMailbox } from 'owa-accounts-store';
import CategoryType from 'owa-service/lib/contract/CategoryType';

/**
 * Gets the MasterCategoryList for the given mailboxInfo. This will be different from the
 * default MasterCategoryList for a connected account since the userConfiguration is different.
 * @param mailboxInfo The mailbox to fetch the user configuration for
 */
export default function getMasterCategoryList(mailboxInfo?: MailboxInfo): CategoryType[] {
    let userConfiguration;

    if (mailboxInfo && isConnectedAccount(mailboxInfo.primarySmtpAddress)) {
        userConfiguration = getUserConfigurationForMailbox(mailboxInfo.primarySmtpAddress);
    } else {
        userConfiguration = getUserConfiguration();
    }

    let masterCategoryList = userConfiguration.MasterCategoryList;

    // the MasterCategoryList can be null for shared mailboxes
    return (masterCategoryList && masterCategoryList.MasterList) || [];
}
